import { alpha, Button } from "@mui/material";

import withStyles from '@mui/styles/withStyles';

export default withStyles(theme => {
    const isDark2 = theme.palette.background.default === '#202326';
    const primary = isDark2 ? '#496878' : theme.palette.primary.main;
    const primaryDark = isDark2 ? '#3b5664' : theme.palette.primary.dark;

    return {
        text: {
            color: primary,
            '&:hover': {
                backgroundColor: alpha(primary, theme.palette.action.hoverOpacity),
            }
        },
        outlined: {
            color: primary,
            border: `1px solid ${alpha(primary, 0.5)}`,
            '&:hover': {
                border: `1px solid ${primary}`,
                backgroundColor: alpha(primary, theme.palette.action.hoverOpacity),
            }
        },
        contained: {
            color: theme.palette.primary.contrastText,
            backgroundColor: primary,
            '&:hover': {
                backgroundColor: primaryDark
            },
            '&:disabled': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                color: '#999999'
            },
        }
    };
}, { name: 'MuiButton-Default' })(Button);